import apiConfig from '../../../config/api'
import {apiRequestorHelper} from '../../../helpers'


export default {
    getTemplates: (params) => {
        return apiRequestorHelper({
            url: apiConfig.url + '/formManager/getTemplates',
            method: 'post',
            body: params
        });
    },

    createTemplate: (data, baseTemplateId) => {
        return apiRequestorHelper({
            url: apiConfig.url + '/formManager/createTemplate' +(baseTemplateId ? ('?baseTemplateId=' + baseTemplateId) : ''),
            method: 'post',
            body: data,
        });
    },

    createTemplateVersion: (templateId) => {
        return apiRequestorHelper({
            url: apiConfig.url + '/formManager/createTemplateVersion',
            method: 'post',
            body: { id : templateId},
        });
    },

    saveTemplateVersion: (data) => {
        return apiRequestorHelper({
            url: apiConfig.url + '/formManager/saveTemplateVersion',
            method: 'post',
            body: data,
        });
    },

    changeStatusForm: (template) => {
        return apiRequestorHelper({
            url: apiConfig.url + '/formManager/changeStatusForm',
            method: 'post',
            body: template,
        });
    },

    getTemplateVersions: (templateId) => {
        return apiRequestorHelper({
            url: apiConfig.url + '/formManager/getFormTemplateVersions/' + templateId,
            method: 'get'
        });
    },
    getTemplateVersion: (templateId, templateVersionId) => {
        return apiRequestorHelper({
            url: apiConfig.url + '/formManager/getFormTemplateVersion',
            method: 'post',
            body: { 
                templateId,
                templateVersionId
            }
        });
    },
    setTemplateVersion: (templateId, version) => {
        return apiRequestorHelper({
            url: apiConfig.url + '/formManager/setTemplateVersion/' + templateId +'/version/'+ version,
            method: 'post',
        });
    },
};
